import { render, staticRenderFns } from "./ModalProductCreateEdit.vue?vue&type=template&id=2a14174c&"
import script from "./ModalProductCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ModalProductCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports